import { ReactNode, useCallback, useState } from 'react';
import { Collapse } from '@mui/material';
import classNames from 'classnames';

import { AgExpandIcon } from 'app/agriculture/infobox/common/AgExpandIcon/AgExpandIcon';

import './StackBox.scss';
import { StackBoxSection } from 'app/agriculture/components/BoxStack/components/StackBoxSection/StackBoxSection';

interface StackBoxProps {
    id?: string;
    title: string;
    icon?: ReactNode;
    priority?: 'normal' | 'high';
    defaultExpanded?: boolean;
    children?: ReactNode;
    className?: string;
}

function StackBox({
    id,
    className,
    title,
    icon,
    priority = 'normal',
    children,
    defaultExpanded = false,
}: StackBoxProps) {
    const [expanded, setExpanded] = useState(defaultExpanded);

    const handleClick = useCallback(() => {
        setExpanded((expanded) => !expanded);
    }, []);

    return (
        <div
            id={id}
            data-testid="StackBox"
            className={classNames('StackBox', `StackBox--${priority}-priority`, className, {
                'StackBox--expanded': expanded,
            })}
        >
            <button id={`${id}-header`} className="StackBox__header" onClick={handleClick}>
                {icon != null && <div className="StackBox__icon">{icon}</div>}
                <h5 className="StackBox__title" title={title}>
                    {title}
                </h5>
                <div className="StackBox__expand-icon">
                    <AgExpandIcon expanded={expanded} />
                </div>
            </button>
            <Collapse
                in={expanded}
                mountOnEnter={true}
                unmountOnExit={true}
                classes={{
                    root: 'StackBox__collapse',
                    wrapper: 'StackBox__collapse-wrapper',
                }}
            >
                <div className="StackBox__content">{children}</div>
            </Collapse>
        </div>
    );
}

StackBox.Section = StackBoxSection;

export { StackBox };
